import { useCallback } from 'react';

import useEnum from '@hooks/useEnum';

import PendenciaService from '@services/PendenciaService';

const useDocumentosPendencia = () => {
    const fetch = useCallback(() => PendenciaService.listarDocumentos(), []);
    const { data, loading, error } = useEnum(fetch);

    return { data, loading, error };
}

export default useDocumentosPendencia;